<div class="fileUpload">
    <input (change)="emitFile($event.target.files)"
           [accept]="[acceptedFileTypes.join(','), acceptedFileExtensions.join(',')].join(',')"
           [id]="'upload' + id"
           type="file"
           [disabled]="disabled"
           #fileUpload>
    <label [htmlFor]="'upload' + id">
        <i class="fas fa-upload"></i>&nbsp;
        <span [i18n]="labelKey"></span>
    </label>
</div>